import { render, staticRenderFns } from "./MarkInput.vue?vue&type=template&id=010f9a30&"
import script from "./MarkInput.vue?vue&type=script&lang=js&"
export * from "./MarkInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports